import React from 'react'
import { Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';
import HeadingBox from '../components/HeadingBox'


const date = new Date();


function Iframe(props) {
    console.log("URL Calling : ", props.src)
    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}

class Finance extends React.Component {

    constructor(props) {
        super(props);


        this.state = {

            fromDate: new Date(date.getFullYear(), date.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date().toISOString().substring(0, 10),

            srcURL_MonthToDateFees: '',
            srcURL_CardsVehicleMonthSummary: '',
            srcURL_CombinationHistoryReport: '',

            //reportBaseURL: 'http://localhost:40383/Reports?',
            //reportBaseURL: 'https://altpaymerchants.com/TELEMATICSREPORTINGSERVICE/Reports?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Reports?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',


        }

        this.submitHandler = this.submitHandler.bind(this)
        this.changeHandler = this.changeHandler.bind(this)

    }
    componentDidMount() {

        this.MonthToDateFees();
        this.CardsVehicleMonthSummary();
        this.CombinationHistoryReport();

    }

    async MonthToDateFees() {

        let FromDate = this.state.fromDate;
        let ToDate = this.state.toDate;
        let UserBranchID = localStorage.getItem('selectedBranch')

        let reportName = "MonthToDateFees";
        let URL_PARAMETERS = 'reportName=' + reportName + '&FromDate=' + FromDate + '&ToDate=' + ToDate + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_MonthToDateFees: ReportFullURL })
    }

    async CardsVehicleMonthSummary() {

        let FromDate = this.state.fromDate;
        let ToDate = this.state.toDate;
        let UserBranchID = localStorage.getItem('selectedBranch')

        let reportName = "CardsVehicleMonthSummary";
        let URL_PARAMETERS = 'reportName=' + reportName + '&FromDate=' + FromDate + '&ToDate=' + ToDate + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_CardsVehicleMonthSummary: ReportFullURL })
    }


    async submitHandler(e) {
        this.CombinationHistoryReport();
    }

    async CombinationHistoryReport() {

        console.log('Inside  CombinationHistoryReport')
        let FromDate = this.state.fromDate;
        let ToDate = this.state.toDate;
        let UserBranchID = localStorage.getItem('selectedBranch')

        let reportName = "CombinationHistoryReport";
        console.log('here');
        let URL_PARAMETERS = 'reportName=' + reportName + '&FromDate=' + FromDate + '&ToDate=' + ToDate + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_CombinationHistoryReport: ReportFullURL })

        console.log(' exit CHR')
    }

    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
      }

    render() {
        return (
            <div>

                <Row className="m-0">
                    <div className="col-md-12 col-12">
                        <HeadingBox title="Only those Shell Cards that have remained mapped to a Vehicle for more than 15 minutes will be charged and appear in this section."></HeadingBox>
                    </div>
                </Row>

                <Row className="m-3">
                    <div className="col-md-6 col-12" style={{ marginLeft: '-17px !important' }}>
                        <Card className="p-3">
                            <Card.Body>
                                <Iframe src={this.state.srcURL_MonthToDateFees} height="430" width="100%" />
                            </Card.Body>

                        </Card>

                    </div>
                    <div className="col-md-6 col-12" style={{ marginLeft: '-17px !important' }}>
                        <Card className="p-3">
                            <Card.Body>

                                <Iframe src={this.state.srcURL_CardsVehicleMonthSummary} height="430" width="100%" />

                            </Card.Body>
                        </Card>
                    </div>

                </Row>

                <Row className="m-3">

                    <div className="col-md-12 col-12" style={{ marginLeft: '-17px !important' }}>
                        <Card className="p-3">
                            <Card.Body>
                                <Row>
                                    <div className="col-md-6 col-12">
                                        <div className="form-label-group">
                                            <input type="date" id="fromDate" name="fromDate" value={this.state.fromDate} onChange={this.changeHandler} className="form-control" />
                                            <label htmlFor="country-floating">Choose From Time</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <div className="form-label-group">
                                            <input type="date" id="toDate" name="toDate" value={this.state.toDate} onChange={this.changeHandler} className="form-control" />
                                            <label htmlFor="country-floating">Choose To Time</label>
                                        </div>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-12 " style={{ textAlign: 'center' }}>
                                        <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.submitHandler} >Generate Report</button>
                                    </div>
                                </Row>
                                <Iframe src={this.state.srcURL_CombinationHistoryReport} height="430" width="100%" />
                            </Card.Body>

                        </Card>

                    </div>
                </Row>

                {/* 
                <Row className="p-3">

                    <Card className="p-3">

                        <Card.Title>
                            <h4 className="pull-left">Combination History</h4>
                        </Card.Title>

                        <Card.Body className="pt-0">

                            <div className="form-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-label-group">
                                            <select className="form-control" placeholder="Select Month">
                                                <option value="">Select Month</option>
                                                <option value="1">January</option>
                                                <option value="2">February</option>
                                                <option value="3">March</option>
                                                <option value="4">April</option>
                                                <option value="5">May</option>
                                                <option value="6">June</option>
                                                <option value="7">July</option>
                                                <option value="8">August</option>
                                                <option value="9">Spetember</option>
                                                <option value="10">October</option>
                                                <option value="11">November</option>
                                                <option value="12">December</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-label-group">
                                            <select className="form-control" placeholder="Select Year">
                                                <option value="">Select Year</option>
                                                <option value="2020">2020</option>
                                                <option value="2021">2021</option>
                                                <option value="2022">2022</option>
                                                <option value="2023">2023</option>
                                                <option value="2024">2024</option>
                                                <option value="2025">2025</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">&nbsp;</div>
                                </div>
                            </div>

                            <AdvanceTable data={this.state.data} columns={this.state.columns}>

                            </AdvanceTable>

                        </Card.Body>

                    </Card>

                </Row>
 */}

            </div>



        );
    }
}


export default Finance;